module.exports = __webpack_public_path__ + "img/pingtai1.3be27f66.webp";